// The guided tour of the Time Entry Audit, for the admin, PMO, finance and HR
// people who use it to work out why logged time is not costing against SOW
// milestones. Steps point at [data-tour] anchors on TimeEntryAuditPage. The
// page has two tabs, so every step carries a `before` that puts the page on
// the tab it describes; stepping backwards then leaves the page as it was
// going forwards.

export const TIME_ENTRY_AUDIT_TOUR_ID = 'time-entry-audit';

const switchTo = (label) => {
  const tabs = document.querySelector('[data-tour="tabs"]');
  const btn = [...(tabs?.querySelectorAll('button') || [])].find(b => b.textContent.trim() === label);
  btn?.click();
};
const onGaps = () => switchTo('Gaps by SOW');
const onLedger = () => switchTo('Ledger');

export const timeEntryAuditTourSteps = [
  {
    title: 'The Time Entry Audit',
    target: '[data-tour="page-header"]',
    before: onGaps,
    body: [
      'The SOW Costs tab prices labour from the time log, but only time that carries a milestone lands against one, and only time with a day rate costs anything. This page shows where logged time is falling short of that, so the cause can be found rather than guessed at.',
      'Use Next to walk through, or Skip if you would rather explore. Either way it will not pop up again; the ? by the title replays it.',
    ],
  },
  {
    title: 'The range and the totals',
    target: '[data-tour="summary"]',
    before: onGaps,
    body: [
      'Pick a date range with the presets or the From and To dates. The tiles total the hours in that range, the hours on a SOW with no milestone, the hours with no day rate, and the split between the three routes time comes through: against a task, against a SOW directly, or against an overhead category.',
      'Only the SOW route has ever offered a milestone picker, so a high task share is usually the answer to why milestones are empty.',
    ],
  },
  {
    title: 'Gaps by SOW',
    target: '[data-tour="gaps-table"]',
    before: onGaps,
    body: [
      'One row per SOW with time logged in the range, worst first: the hours, how many have no milestone and what share that is, how many have no rate, which route most of them came through, and how many live milestones the SOW has to choose from. A SOW with no milestones at all cannot have its time assigned until some are created.',
      'Click a row to see the entries behind it. Where you may edit time for others, each entry has a milestone dropdown so it can be assigned without leaving the page.',
    ],
  },
  {
    title: 'The Ledger',
    target: '[data-tour="ledger-filters"]',
    before: onLedger,
    body: [
      'Every entry in the range as a row, newest first, with the route it came through, the screen that logged it where the entry recorded one, its milestone and its rate. Filter to entries missing a milestone or a rate, to one route or one screen, or to a person or a SOW.',
      'Entries logged before the screen was recorded show "not recorded" for the screen; that is the truth of the data, not a fault.',
      'Entries written from approved leave show "Approved leave" as the screen. Nobody typed those: they follow the leave request.',
    ],
  },
];
